define('app/sf/key/value/pair/sf-key-value-pair-filter',[],function () {
	return function keyValuePairFilter(input) {
		var out = [];
		angular.forEach(input, function (value, key) {
			out.push({
				key: key,
				value: value
			});
		});
		return out;
	};
});
